var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12 modules" }, [
    _c("div", { staticClass: "form-group mt-10" }, [_vm._v("Add Module")]),
    _c("div", { staticClass: "row label_container" }, [
      _c("span", { staticClass: "checkbox mr-12" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.moduleAccess,
                expression: "moduleAccess",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.moduleAccess)
                ? _vm._i(_vm.moduleAccess, null) > -1
                : _vm.moduleAccess,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.moduleAccess,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.moduleAccess = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.moduleAccess = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.moduleAccess = $$c
                }
              },
            },
          }),
          _c("span", { staticClass: "cr" }),
        ]),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.moduleName,
            expression: "moduleName",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.moduleName },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.moduleName = $event.target.value
          },
        },
      }),
      _c(
        "button",
        {
          staticClass: "btn emergo-green-button",
          attrs: { type: "button", disabled: _vm.moduleName.length == 0 },
          on: { click: _vm.moduleButton },
        },
        [_vm._v(" Save ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }